export default __webpack_public_path__ + "static/eymard-2ecf290296e3ea81f5a0b1ac9c425286.jpg";